import { Model } from ".";

export default class TransactionErrorType extends Model {
	get singularNoun() {
		return "transaction error type";
	}

	resource() {
		return "sales/transaction-error-types";
	}
}
